"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = require("swiper");
var hamburgerMenuScripts = function () {
    var hamburgerMenu = document.querySelector('#hamburgerMenu');
    var toggleNav = document.querySelector('#toggleNav');
    var toggleClass = 'is_set';
    if (hamburgerMenu !== null && toggleNav !== null) {
        hamburgerMenu.addEventListener('click', function () {
            hamburgerMenu.classList.toggle(toggleClass);
            toggleNav.classList.toggle(toggleClass);
        });
    }
};
var aboutUsModal = function () {
    var openButton = document.querySelectorAll('.aboutus-page-link');
    var _loop_1 = function (i) {
        openButton[i].addEventListener('click', function () {
            var modalName = openButton[i].dataset.modal;
            var modalContainer = document.querySelector('#' + modalName);
            if (modalContainer) {
                modalContainer.classList.add('is-active');
            }
        });
    };
    for (var i = 0; i < openButton.length; i++) {
        _loop_1(i);
    }
    var closeButton = document.querySelectorAll('.modal-close');
    for (var i = 0; i < closeButton.length; i++) {
        closeButton[i].addEventListener('click', function () {
            var modalContainerClose = document.querySelectorAll('.modal-container');
            for (var ii = 0; ii < modalContainerClose.length; ii++) {
                modalContainerClose[ii].classList.remove('is-active');
            }
        });
    }
};
// トップ施工事例スライダー
var topWorksSwiper = function () {
    var swiper = new swiper_1.default('.top-works-slider', {
        modules: [swiper_1.Pagination, swiper_1.Navigation, swiper_1.Autoplay],
        loop: true,
        slidesPerView: 1.4,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
            el: '.pickup-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            768: {
                slidesPerView: 3.4,
                spaceBetween: 20
            }
        }
    });
    swiper.init();
};
var hiddenEntryBtn = function () {
    var entryBtn = document.querySelector('.entry-button');
    var footer = document.querySelector('footer');
    // 応募するボタンがない時とフッターがない時は終了
    if (!entryBtn || !footer)
        return;
    // 交差オブザーバー(Intersection Observer API)を使用して要素の重なりを監視
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entryBtn.classList.add('hidden');
            }
            else {
                entryBtn.classList.remove('hidden');
            }
        });
    });
    observer.observe(footer);
};
var headerMargin = function () {
    var header = document.getElementById('header');
    if (header === null) {
        return;
    }
    var headerHeight = header.clientHeight;
    var body = document.querySelector('body');
    if (body === null) {
        return;
    }
    var addMargin = document.querySelectorAll('.header-margin-add');
    for (var i = 0; i < addMargin.length; i++) {
        addMargin[i].style.marginTop = headerHeight + 'px';
    }
};
document.addEventListener('DOMContentLoaded', function () {
    hamburgerMenuScripts();
    aboutUsModal();
    topWorksSwiper();
    headerMargin();
});
window.addEventListener('load', function () {
    hiddenEntryBtn();
});
